import React from 'react';
import { Field } from 'redux-form';
import { FormControlLabel, Radio } from '@material-ui/core';
import InlineFormRadioGroup from '../../../Auth/Registration/components/InlineFormRadioGroup';
import { required } from '../../../../utils/validators';
import { FINALIZE_BUY_FEE_METHODS } from '../../../../constants';
import { StyledRadio } from './StyledRadio';

const FinalizePaymentMethodPicker = ({ hasAch, hasFlooring }) => {
  return (
    <Field name="finalize_payment_method" component={InlineFormRadioGroup} row validate={required}>
      {hasAch && (
        <FormControlLabel
          style={{ marginLeft: '-7px' }}
          control={<StyledRadio />}
          value={FINALIZE_BUY_FEE_METHODS.ACH}
          label="ACH"
          disabled={!hasAch}
        />
      )}
      {hasFlooring && (
        <FormControlLabel
          control={<StyledRadio />}
          value={FINALIZE_BUY_FEE_METHODS.FLOORING}
          label="Flooring"
          disabled={!hasFlooring}
        />
      )}
      <FormControlLabel
        control={<StyledRadio />}
        value={FINALIZE_BUY_FEE_METHODS.OTHER}
        label="Other"
      />
    </Field>
  );
};
export default FinalizePaymentMethodPicker;
